import React, {useState} from 'react';
import {AntdTable} from "../../components/custom/AntdTable";
import {TransactionsGraph} from "./TransactionsGraph";
import {AntdModal} from "../../components/custom/AntdModal";
import {getFilterValue} from "../../helpers";


export function TransactionsTab({transactionsInfo}) {

    const [isModalVisible, setIsModalVisible] = useState(false);

    const columns = [
        {
            key: 'plant',
            title: 'Plant',
            dataIndex: 'plant',
            onFilter: (value, record) => record['plant'] === value,
            filters: getFilterValue(transactionsInfo.tableData, 'plant')
        }, {
            key: 'sloc',
            title: 'Storage Location',
            dataIndex: 'storage_location',
            onFilter: (value, record) => record['storage_location'] === value,
            filters: getFilterValue(transactionsInfo.tableData, 'storage_location')
        }, {
            key: 'document_number',
            title: 'Document Number',
            dataIndex: 'document_number',
        }, {
            key: 'document_item',
            title: 'Document Item',
            dataIndex: 'document_item',
        }, {
            key: 'document_description',
            title: 'Document Description',
            dataIndex: 'document_description',
        }, {
            key: 'date',
            title: 'Posting Date',
            dataIndex: 'Posting Date',
            render: date => date.split(' ')[0]
        }, {
            key: 'movement_type',
            title: 'Movement Type',
            dataIndex: 'Movement Type',
            onFilter: (value, record) => record['Movement Type'] === value,
            filters: getFilterValue(transactionsInfo.tableData, 'Movement Type')
        }, {
            key: 'quantity',
            title: 'Quantity',
            dataIndex: 'Quantity',
        }, {
            key: 'description',
            title: 'Description',
            dataIndex: 'Movement Type Text',
        },
    ]

    return <>
        {(transactionsInfo.graphData && transactionsInfo.graphData.length > 0) &&
            <div style={{float: 'right', color: '#004987'}} className='beautiful-link'
                 onClick={() => setIsModalVisible(true)}>Open graph
            </div>}
        <AntdTable tableSize={'small'} scroll={300} data={transactionsInfo.tableData} columns={columns}/>

        <AntdModal isModalVisible={isModalVisible}
                   title={'Transaction Data'}
                   onCancel={() => setIsModalVisible(false)}
                   onOk={() => setIsModalVisible(false)}
        >
            <TransactionsGraph graphData={transactionsInfo.graphData}/>
        </AntdModal>

    </>

}
